/**
 * Gets item from an array by `currentItemIndex` in proper way.
 *
 * In order to use the same approach for getting the selected item in all places from warehouse's tables.
 *
 * @param items A list of items
 * @param currentItemIndex Currently selected row index of {@link ItemWorkflowVirtualizedTable}
 * @returns
 */
// export function getSelectedItem<T extends ReceiptItem | StockReceiptItem | StockReceiptItem | PackingStickerItem | PickingItem>(
export function getSelectedItem(items, currentItemIndex) {
    if (currentItemIndex === undefined || currentItemIndex < 0 /* may be -1 */ || !items?.length)
        return undefined;
    return items[currentItemIndex];
}
